import { SVGProps } from 'react';

const TrashOutlined = ({
  width = 15,
  height = 18,
  fill = '#FF8200',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 18"
    {...otherProps}>
    <path
      d="M14.0146 4.99578V14.9867C14.0001 17 13.0001 18 11.0219 18C7.00098 18 8.99519 18 4.97438 18C3.00007 18 1.98279 17.0159 1.98279 15.0026V4.9971L4.00007 5C4.00007 5 3.97009 10.3309 4.00007 15C4.01014 15.5161 4.47704 15.99 5.00007 16C9.01578 16.025 7.00626 16.0146 11.0219 15.9896C11.5001 15.9867 11.9961 15.546 12.0001 15V4.99764L14.0146 4.99578ZM4.98986 2.99802L5.00007 1C5.00007 0.5 5.45655 0.0123819 6.00007 0H10.0057C10.5001 0 11.0001 0.5 11.0079 1.00022V2.99822H14.4993C15.052 2.99822 15.5001 3.44629 15.5001 3.99901C15.5001 4.55181 15.0519 4.99991 14.4991 4.99981L1.4998 4.99729C0.947594 4.99718 0.5 4.5495 0.5 3.9973C0.5 3.44493 0.947838 2.99719 1.5002 2.9973L4.98986 2.99802ZM9.00342 2.99802V1.99894H6.99311V2.99802H9.00342Z"
      fill={fill}
    />
  </svg>
);

export default TrashOutlined;
